module.exports = "<ngb-timepicker [id]=\"id\" [(ngModel)]=\"model\" (ngModelChange)=\"modelChanged($event)\" [size]=\"size\"></ngb-timepicker>\n\n"